import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\FuneralHomePartner\Elys\ElysActionController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/Elys/ElysActionController.php
* @route '/api/company/{company}/elys/action'
*/
const ElysActionController = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: ElysActionController.url(args, options),
    method: 'post',
})

ElysActionController.definition = {
    methods: ["post"],
    url: '/api/company/{company}/elys/action',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\FuneralHomePartner\Elys\ElysActionController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/Elys/ElysActionController.php
* @route '/api/company/{company}/elys/action'
*/
ElysActionController.url = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { company: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { company: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            company: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
    }

    return ElysActionController.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\FuneralHomePartner\Elys\ElysActionController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/Elys/ElysActionController.php
* @route '/api/company/{company}/elys/action'
*/
ElysActionController.post = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: ElysActionController.url(args, options),
    method: 'post',
})

export default ElysActionController